import { objectEntries } from 'src/utils/objectEntries';
import { objectFromEntries } from 'src/utils/objectFromEntries';

export class CustomFilters {
  static readonly prefix = 'CF';

  static getParamName(id: string): string {
    return `${this.prefix}${id}`;
  }

  static extractQueryParams<T extends string, M extends string>(params: Record<T, T[] | T>): Record<M, T[] | T> {
    const entries = objectEntries(params)
      .filter(([key]) => key.startsWith(this.prefix))
      .map(([key, value]) => [key.replace(this.prefix, '') as M, value] as const);

    return objectFromEntries(entries);
  }
}
